import { atom, useAtom, useSetAtom } from "jotai";
import { TableType } from "./useTables";

export interface TableMap {
  name: string;
  id: string;
  tables: TableType[];
}

export const tableMapsAtom = atom<TableMap[]>([]);
const useTableMaps = () => {
  const atom = useAtom(tableMapsAtom);
  return atom;
};

export const useSetTableMaps = () => useSetAtom(tableMapsAtom);

export default useTableMaps;
